// Sort value for the Jobs "PO #" column.
//
// POs are stored as TEXT (poNumber: string | null) but are pure numeric — verified
// across all live POs: 15× 3-digit, 133× 4-digit, 306× 5-digit, zero alphanumeric/
// dashed. The Jobs table must therefore sort them by NUMERIC value, not
// lexicographically. String comparison goes char-by-char, so "2511" sorts in the
// middle of the 25100s ("25109" < "2511" because '0' < '1' at the 4th char) — the
// bug this fixes. Returning a number routes the sort through useSortable's numeric
// branch (a - b) so all 3-digit POs group before all 4-digit before all 5-digit.
//
// Blank/null — and any non-numeric, defensively (none exist today) — return null so
// useSortable's null handling sinks them deterministically to the end.
export function poSortValue(po: string | null | undefined): number | null {
  if (po == null) return null;
  const trimmed = po.trim();
  if (trimmed === '') return null;
  const n = Number(trimmed);
  return Number.isNaN(n) ? null : n;
}
